import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnDestroy } from '@angular/core';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { ModalService } from '@base/services/private/modal.service';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-sent-failed',
  imports: [ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, forwardRef(() => TranslatePipe)],
  templateUrl: './modal-sent-failed.component.html',
  styleUrl: './modal-sent-failed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSentFailedComponent implements OnDestroy {
  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);

  @Input() modalId = '';
  @Input() header = 'SENT_FAILED';
  @Input() description = 'WOULD_YOU_LIKE_TO_TRY_AGAIN';

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * Closes the modal by its ID.
   * @returns void
   */
  close(): void {
    this.modalSrv.close(this.modalId);
  }
}
